import { Button, Text } from "@/design-system";
import { Linkedin, MessageCircle } from "lucide-react";

interface ShareButtonsProps {
  url: string;
  title: string;
}

const FIDEXA_WHATSAPP = "5519936195831";
const FIDEXA_LINKEDIN = "https://www.linkedin.com/company/fidexa-servicos-credito";

/**
 * Compartilhar o post.
 *
 * São links, não ações — por isso `Button asChild` com `<a>` dentro, que
 * mantém o alvo de 44px do sistema (o par de círculos de 36px do código
 * anterior ficava abaixo do mínimo de toque) e o anel de foco padrão.
 */
export const ShareButtons = ({ url, title }: ShareButtonsProps) => {
  const whatsappHref = `https://wa.me/${FIDEXA_WHATSAPP}?text=${encodeURIComponent(`${title} ${url}`)}`;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Text as="span" size="small" tone="subtle">
        Compartilhar:
      </Text>
      <Button asChild variant="secondary" size="sm" shape="circle" aria-label="Compartilhar no WhatsApp">
        <a href={whatsappHref} target="_blank" rel="noopener noreferrer">
          <MessageCircle aria-hidden="true" />
        </a>
      </Button>
      <Button asChild variant="secondary" size="sm" shape="circle" aria-label="Compartilhar no LinkedIn">
        <a href={FIDEXA_LINKEDIN} target="_blank" rel="noopener noreferrer">
          <Linkedin aria-hidden="true" />
        </a>
      </Button>
    </div>
  );
};
